import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Construction from 'src/store/models/Construction';
import City from 'src/store/models/City';
import State from 'src/store/models/State';
import Company from 'src/store/models/Company';
import AdBanner from 'src/store/models/AdBanner';
import Filters from 'src/components/Filters';
import CitySwitcher from 'src/components/CitySwitcher';
import Loading from 'quasar/src/plugins/Loading.js';import QImg from 'quasar/src/components/img/QImg.js';;
import { groupBy } from 'lodash';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import { mapGetters } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import CityGroup from "../components/Results/CityGroup.vue";
export default {
  name: 'SearchResults',
  meta: function meta() {
    var title = "Vendita Case, Appartamenti e Immobili di Nuova Costruzione";
    var description = "Case, Ville, Appartamenti, Attici, Maisonette con giardino in fase di costruzione o in pronta consegna";
    if (this.state && !this.city) {
      title = "Nuove costruzioni provincia di ".concat(this.state.name, ", in vendita direttamente dai costruttori");
      description = "Immobili di nuova costruzione proposti direttamente dalle imprese nella Provincia di ".concat(this.state.name, ". Case, Ville, Appartamenti, Attici, Maisonette con giardino in fase di costruzione o in pronta consegna");
    }
    if (this.city) {
      title = "Case di nuova costruzione comune di ".concat(this.city.name);
      description = "Immobili di nuova costruzione proposti direttamente dai costruttori nel Comune di ".concat(this.city.name, ". Case, Ville, Appartamenti, Attici, Maisonette con giardino in fase di costruzione o in pronta consegna");
    }
    if (this.company) {
      title = "Case di nuova costruzione, in vendita da ".concat(this.company.name);
      description = "Immobili di nuova costruzione proposti direttamente da ".concat(this.company.name, ". Case, Ville, Appartamenti, Attici, Maisonette con giardino in fase di costruzione o in pronta consegna");
    }
    return {
      // sets document title
      title: title,
      // meta tags
      meta: {
        description: {
          name: 'description',
          content: description
        },
        keywords: {
          name: 'keywords',
          content: "trovacantieri cantieri vendita case immobili nuovo costruttore diretta direttamente ".concat(this.state ? this.state.name : '', " ").concat(this.city ? this.city.name : '')
        },
        equiv: {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=UTF-8'
        }
      }
    };
  },
  components: {
    Swiper: Swiper,
    QImg: QImg,
    SwiperSlide: SwiperSlide,
    Filters: Filters,
    CitySwitcher: CitySwitcher,
    CityGroup: CityGroup
  },
  data: function data() {
    return {
      loading: false,
      showFilters: false,
      showCitySwitcher: false,
      showMap: false,
      selectedMarker: null,
      boundsChanged: false,
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        loop: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1
        }
      },
      swiperOptionNested: {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 4,
        loop: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2
        }
      },
      filters: {
        type: null,
        contract: 'sale',
        from_price: 0,
        to_price: 0,
        from_area: 0,
        to_area: 0,
        typology_category_ids: [],
        bathrooms: null,
        rooms: null,
        bounds: null,
        delivery: null,
        company_id: null
      },
      filtersCount: 0,
      averageCenter: {
        lat: 0,
        lng: 0
      },
      mapZoom: 14,
      citySlug: null,
      stateSlug: null,
      companySlug: null
    };
  },
  watch: {
    'showMap': function showMap() {
      this.$root.$emit('refresh-map');
    },
    'filters': {
      deep: true,
      handler: function handler(val, old) {
        this.$q.cookies.set('search_filters', Buffer.from(JSON.stringify(val)).toString('base64'), {
          expires: 1
        });
      }
    },
    'filters.bounds': {
      deep: true,
      handler: function handler(val, old) {
        if (old) {
          var obj = JSON.parse(old);
          if (obj.center !== '0, 0') {
            this.boundsChanged = true;
          }
        }
      }
    },
    'selectedMarker': function selectedMarker(construction) {
      var _this = this;
      if (!construction) return;
      var slide = document.getElementById(construction.id);
      if (slide && this.swiper.activeIndex !== slide.dataset.index) {
        this.swiper.slideTo(slide.dataset.index);
        this.$nextTick(function () {
          _this.swiper.update();
        });
      }
      construction.$incrementMapVisits();
    },
    '$route.query': function $routeQuery(val, oldval) {
      if (val.page !== oldval.page) {
        this.refetchConstructions(val.page);
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    currentPage: 'entities/constructions/current_page',
    lastPage: 'entities/constructions/last_page',
    perPage: 'entities/constructions/per_page',
    total: 'entities/constructions/total'
  })), {}, {
    google: gmapApi,
    slides: function slides() {
      return Construction.query().withAllRecursive().limit(5).orderBy('distance').get();
    },
    mapConstructions: function mapConstructions() {
      if (this.$route.name === 'referenze') {
        return Construction.query().with('images', function (query) {
          query.orderBy('order_number');
        }).where(function (_record, query) {
          query.where('status', 'in_promotion').orWhere('status', 'in_history');
        }).with('city.state').get();
      } else {
        return Construction.query().with('images', function (query) {
          query.orderBy('order_number');
        }).where('status', 'in_promotion').with('city.state').get();
      }
    },
    constructions: function constructions() {
      return Construction.query().where('status', 'in_promotion').with('images', function (query) {
        query.orderBy('order_number');
      }).with('city.state').orderBy('updated_at', 'desc').get();
    },
    historyConstructions: function historyConstructions() {
      return Construction.query().where('status', 'in_history').with('images', function (query) {
        query.orderBy('order_number');
      }).with('city.state').orderBy('distance').get();
    },
    mapBounds: function mapBounds() {
      var _this2 = this;
      // Calculate google maps zoom based on the coordinates of the constructions
      if (this.google && this.google.maps) {
        var bounds = new this.google.maps.LatLngBounds();
        this.mapConstructions.forEach(function (construction) {
          bounds.extend(new _this2.google.maps.LatLng(construction.latitude, construction.longitude));
        });
        return bounds;
      }
      return null;
    },
    swiper: function swiper() {
      return this.$refs.constructionSwiper.$swiper;
    },
    mapCenter: function mapCenter() {
      if (this.averageCenter) {
        return this.averageCenter;
      }
      if (this.city) {
        return {
          lat: this.city.latitude,
          lng: this.city.longitude
        };
      } else if (this.state) {
        return {
          lat: this.state.latitude,
          lng: this.state.longitude
        };
      }
      return this.averageCenter;
    },
    city: function city() {
      return City.query().where('slug', this.citySlug).first();
    },
    state: function state() {
      return State.query().where('slug', this.stateSlug).first();
    },
    company: function company() {
      return Company.query().where('slug', this.companySlug).first();
    },
    adBanners: function adBanners() {
      return AdBanner.query().where('position', 'list').orderBy('sort_index', 'asc').get();
    },
    showBanners: function showBanners() {
      return !['costruttore_lista', 'referenze', 'altre_proposte_costruttore', 'costruttore'].includes(this.$route.name);
    },
    stateAdBanners: function stateAdBanners() {
      return this.state ? AdBanner.query().where('state_id', this.state.id).where('city_id', null).where('position', 'list').orderBy('sort_index', 'asc').get() : [];
    },
    mapAdBanner: function mapAdBanner() {
      if (this.city) {
        var cityBanner = AdBanner.query().where('city_id', this.city.id).where('position', 'map').orderBy('sort_index', 'asc').first();
        if (cityBanner) {
          return cityBanner;
        }
      }
      if (this.state) {
        return AdBanner.query().where('state_id', this.state.id).where('position', 'map').orderBy('sort_index', 'asc').first();
      }
      return null;
    },
    cityGroups: function cityGroups() {
      return Object.values(groupBy(this.constructions, 'city_id')).map(function (group) {
        return {
          city: group[0].city,
          constructions: group
        };
      });
    },
    historyCityGroups: function historyCityGroups() {
      return Object.values(groupBy(this.historyConstructions, 'city_id')).map(function (group) {
        return {
          city: group[0].city,
          constructions: group
        };
      });
    },
    stringFilters: function stringFilters() {
      return Buffer.from(JSON.stringify(this.filters)).toString('base64');
    }
  }),
  methods: {
    openConstruction: function openConstruction(construction) {
      window.open(construction.url, '_blank');
    },
    updateResultsRoute: function updateResultsRoute() {
      var filters = Buffer.from(JSON.stringify(this.filters)).toString('base64');
      var route = {
        path: this.$route.path,
        query: {
          filters: filters,
          showMap: this.showMap
        }
      };
      if (this.$route.query) {
        if (this.$route.path + this.$route.query.filters === route.path + route.query.filters) {
          return;
        }
      }
      this.$router.replace(route);
      this.$store.commit('app/setLastResultsRoute', route);
    },
    filtersUpdated: function filtersUpdated() {
      if (this.$refs.filtersDialog) {
        this.$refs.filtersDialog.hide();
      }
      this.updateResultsRoute();
      this.refetchConstructions();
    },
    selectMarker: function selectMarker() {
      var slide = this.swiper.slides[this.swiper.realIndex];
      if (slide && this.selectedMarker && this.selectedMarker.id !== slide.id) {
        this.selectedMarker = Construction.find(slide.id);
      }
    },
    toggleMap: function toggleMap() {
      var _this3 = this;
      this.showMap = !this.showMap;
      this.$nextTick(function () {
        _this3.mapZoom = _this3.getBoundsZoomLevel(_this3.mapBounds, {
          width: _this3.$refs.map.$el.clientWidth,
          height: _this3.$refs.map.$el.clientHeight
        });
        _this3.boundsChanged = false;
      });
    },
    getBoundsZoomLevel: function getBoundsZoomLevel(bounds, mapDim) {
      var WORLD_DIM = {
        height: 256,
        width: 256
      };
      var ZOOM_MAX = 17;
      function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
      }
      function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
      }
      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();
      var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;
      var lngDiff = ne.lng() - sw.lng();
      var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;
      var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
      var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
      return Math.min(latZoom, lngZoom, ZOOM_MAX);
    },
    showOnMap: function showOnMap(construction) {
      var _this4 = this;
      if (!this.showMap) {
        this.toggleMap();
      }
      this.$nextTick(function () {
        _this4.selectedMarker = construction;
      });
    },
    refetchConstructions: function refetchConstructions() {
      var _this5 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.$q.loading.show();
      if (this.boundsChanged && this.showMap) {
        this.filters.city_id = null;
        this.filters.state_id = null;
        this.$store.dispatch('entities/constructions/resetPaginator');
      }
      if (!this.showMap) {
        this.filters.bounds = null;
      }
      Construction.api().get('api/constructions', {
        dataKey: 'data',
        params: _objectSpread(_objectSpread({}, this.filters), {}, {
          page: page,
          per_page: 1000
        })
      }).then(function (result) {
        Construction.delete(function (value) {
          var constructionIds = result.response.data.data.map(function (construction) {
            return construction.id;
          });
          return constructionIds.indexOf(value.id) === -1;
        });
        _this5.boundsChanged = false;
        var meta = {
          current_page: result.response.data.current_page,
          last_page: result.response.data.last_page,
          per_page: result.response.data.per_page,
          total: result.response.data.total
        };
        _this5.$store.dispatch('entities/constructions/setPagination', meta);
        _this5.$q.loading.hide();
      }).catch(function () {
        _this5.$q.loading.hide();
      });
    },
    filterCities: function filterCities(val, update, abort) {
      var _this6 = this;
      City.api().get('api/cities', {
        dataKey: 'data',
        params: {
          name: val
        }
      }).then(function (cities) {
        update(function () {
          if (val === '') {
            _this6.cities = [];
          } else {
            _this6.cities = cities;
          }
        });
      }).catch(function () {
        abort();
      });
    },
    adBannersForCity: function adBannersForCity(city) {
      return this.showBanners ? AdBanner.query().where('city_id', city.id).where('position', 'list').orderBy('sort_index', 'asc').get() : [];
    },
    fetchData: function fetchData(resolve) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              Construction.deleteAll();
              if (!_this7.stateSlug) {
                _context.next = 10;
                break;
              }
              if (_this7.state) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return State.$getBySlug(_this7.stateSlug).then(function (response) {
                _this7.filters.state_id = response.data.id;
              }).catch(function (e) {
                console.error(e);
              });
            case 5:
              _context.next = 8;
              break;
            case 7:
              _this7.filters.state_id = _this7.state.id;
            case 8:
              _context.next = 10;
              return AdBanner.api().get('api/ad-banners', {
                params: {
                  state_slug: _this7.stateSlug
                }
              }).catch(function (e) {
                console.error(e);
              });
            case 10:
              if (!_this7.citySlug) {
                _context.next = 17;
                break;
              }
              if (_this7.city) {
                _context.next = 16;
                break;
              }
              _context.next = 14;
              return City.$getBySlug(_this7.citySlug).then(function (response) {
                _this7.filters.city_id = response.data.id;
              }).catch(function (e) {
                console.error(e);
              });
            case 14:
              _context.next = 17;
              break;
            case 16:
              _this7.filters.city_id = _this7.city.id;
            case 17:
              if (!_this7.companySlug) {
                _context.next = 24;
                break;
              }
              if (_this7.company) {
                _context.next = 23;
                break;
              }
              _context.next = 21;
              return Company.$getBySlug(_this7.companySlug).then(function (response) {
                _this7.filters.company_id = response.data.id;
              }).catch(function (e) {
                console.error(e);
              });
            case 21:
              _context.next = 24;
              break;
            case 23:
              _this7.filters.company_id = _this7.company.id;
            case 24:
              if (_this7.filters.bounds && JSON.parse(_this7.filters.bounds).center === '0, 0') {
                _this7.filters.bounds = null;
              }
              return _context.abrupt("return", Construction.api().get('api/constructions', {
                dataKey: 'data',
                params: _objectSpread(_objectSpread({}, _this7.filters), {}, {
                  per_page: 1000
                })
              }).then(function (result) {
                var meta = {
                  current_page: result.response.data.current_page,
                  last_page: result.response.data.last_page,
                  per_page: result.response.data.per_page,
                  total: result.response.data.total
                };
                _this7.$store.dispatch('entities/constructions/setPagination', meta);
                if (result.response.data.data.length) {
                  var mapConstructions = result.response.data.data.filter(function (construction) {
                    return construction.status === 'in_promotion' || construction.status === 'in_history';
                  });
                  var center = mapConstructions.reduce(function (center, construction) {
                    if (construction.status === 'in_promotion' || construction.status === 'in_history') {
                      center.lat += construction.latitude;
                      center.lng += construction.longitude;
                    }
                    return center;
                  }, {
                    lat: 0,
                    lng: 0
                  });
                  center.lat /= mapConstructions.length;
                  center.lng /= mapConstructions.length;
                  _this7.averageCenter = center;
                  _this7.boundsChanged = false;
                }
              }));
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  serverPrefetch: function serverPrefetch(_ref) {
    var store = _ref.store,
      redirect = _ref.redirect,
      ssrContext = _ref.ssrContext,
      urlPath = _ref.urlPath,
      publicPath = _ref.publicPath;
    Loading.show();
    Construction.deleteAll();
    this.stateSlug = this.$route.params.stateSlug;
    this.citySlug = this.$route.params.citySlug;
    this.companySlug = this.$route.params.companySlug;

    // get filters from cookie search_filters
    var filters = this.$q.cookies.get('search_filters');
    // base64 decode filters and json decode filters and store to this.filters
    if (filters && !this.$route.query.reset_filters) {
      try {
        this.filters = JSON.parse(Buffer.from(filters, 'base64').toString());
      } catch (e) {
        console.log(e);
      }
    }
    if (this.$route.query.filters && !this.$route.query.reset_filters) {
      try {
        var parsedFilters = JSON.parse(Buffer.from(this.$route.query.filters, 'base64').toString());
        if (parsedFilters) {
          this.filters = parsedFilters;
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (this.city) {
      this.filters.city_id = this.city.id;
    }
    if (this.state) {
      this.filters.state_id = this.state.id;
    }
    if (this.company) {
      // keep only the company id filter
      this.filters = {
        type: null,
        contract: null,
        from_price: 0,
        to_price: 0,
        from_area: 0,
        to_area: 0,
        typology_category_ids: [],
        bathrooms: null,
        bounds: null,
        rooms: null,
        delivery: null,
        company_id: this.company ? this.company.id : null,
        city_ids: []
      };
    }
    return this.fetchData();
  },
  beforeMount: function beforeMount() {
    Construction.deleteAll();
  },
  mounted: function mounted() {
    var _this8 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var filters, parsedFilters;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // get filters from cookie search_filters
            filters = _this8.$q.cookies.get('search_filters'); // base64 decode filters and json decode filters and store to this.filters
            if (filters && !_this8.$route.query.reset_filters) {
              try {
                _this8.filters = JSON.parse(Buffer.from(filters, 'base64').toString());
              } catch (e) {
                console.log(e);
              }
            }
            if (_this8.$route.query.filters && !_this8.$route.query.reset_filters) {
              try {
                parsedFilters = JSON.parse(Buffer.from(_this8.$route.query.filters, 'base64').toString());
                if (parsedFilters) {
                  _this8.filters = parsedFilters;
                }
              } catch (e) {
                console.log(e);
              }
            }
            if (_this8.$route.query.reset_filters) {
              // Clear search_filters cookie
              _this8.$q.cookies.remove('search_filters');
            }
            _this8.stateSlug = _this8.$route.params.stateSlug;
            _this8.citySlug = _this8.$route.params.citySlug;
            _this8.companySlug = _this8.$route.params.companySlug;
            if (_this8.city) {
              _this8.filters.city_id = _this8.city.id;
              _this8.filters.bounds = null;
            }
            if (_this8.state) {
              _this8.filters.state_id = _this8.state.id;
              _this8.filters.bounds = null;
            }
            if (_this8.company) {
              // keep only the company id filter
              _this8.filters = {
                type: null,
                contract: null,
                from_price: 0,
                to_price: 0,
                from_area: 0,
                to_area: 0,
                typology_category_ids: [],
                bathrooms: null,
                bounds: null,
                rooms: null,
                delivery: null,
                company_id: _this8.company.id,
                city_ids: []
              };
            }
            _this8.updateResultsRoute();
            _context2.next = 13;
            return _this8.fetchData();
          case 13:
            _this8.showMap = !_this8.isMobile || _this8.$route.query.showMap;
            if (_this8.showMap) {
              _this8.$nextTick(function () {
                _this8.mapZoom = _this8.getBoundsZoomLevel(_this8.mapBounds, {
                  width: _this8.$refs.map.$el.clientWidth,
                  height: _this8.$refs.map.$el.clientHeight
                });
                _this8.boundsChanged = false;
              });
            }
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};